export default __webpack_public_path__ + "static/media/Individual_Health_Insurance_Icon.2c750f17.svg";